export default "<ion-app>\n  <ion-router-outlet [animated]=\"false\"></ion-router-outlet>\n</ion-app>\n";